<template>
  <!-- 展示当前绑定签到，沿用其免费或专享分支 -->
  <SignInParticipation v-if="activity" :activity-id="activity.id" :sign-category="Number(activity.signCategory || 0)" :display-title="activity.signDisplayTitle || ''" compact @detail="openPromotion(activity)" @claimed="loadMember" />
  <ErrorNotice v-else-if="error" class="member-sign-error" :message="error"><button type="button" @click="load">重试</button></ErrorNotice>
</template>
<script setup>
import ErrorNotice from './feedback/ErrorNotice.vue'
import { personalSignInActivity } from '../services/activities/signInBinding.js';
import { ref, watch, onBeforeUnmount } from 'vue';
import SignInParticipation from './SignInParticipation.vue';
import { webApi } from '../services/webApi';
import { authStorage } from '../services/http';
import { useAppContext } from '../composables/appContext';
const { isLoggedIn, openPromotion, loadMember } = useAppContext();
const activity = ref(null), error = ref('');
let sequence = 0;
async function load() {
  const current = ++sequence, token = authStorage.getToken();
  activity.value = null; error.value = '';
  if (!isLoggedIn.value || !token) return;
  try {
    const [items, binding] = await Promise.all([webApi.activities(), webApi.signDisplay()]);
    if (current !== sequence || token !== authStorage.getToken()) return;
    if (!Array.isArray(items)) throw new Error('签到活动查询失败');
    activity.value = personalSignInActivity(items, binding);
  } catch (cause) { if (current === sequence && token === authStorage.getToken()) error.value = cause.message || '签到活动查询失败'; }
}
watch(isLoggedIn, load, { immediate: true });
onBeforeUnmount(() => { sequence++; });
</script>
<style scoped>
.member-sign-error { margin-top: 24px; color: #b54c4c; }
.member-sign-error button { background: transparent; color: #3085b6; }
</style>
